<div class="login-page">
    <div class="logo">Hyper<span class="accent">Med</span></div>
    <div class="login-card">
        <div class="login-card-header">
            <div class="title" [innerHTML]="title"></div>
            <div class="logout-button" *ngIf="isLoggedIn" (click)="logout()" title="Déconnexion">
                <object class="button" type="image/svg+xml" data="/assets/icons-white/sortie.svg"></object>
            </div>
        </div>
        <router-outlet></router-outlet>
    </div>
    <span [matTooltip]="fullVersion" [matTooltipClass]="'tooltip-version'" matTooltipPosition="right">{{getVersion()}}</span>
</div>
